import theme from 'theme'

const FREE_ACCESS_LIMIT = '50.000'
const LIMITED_ACCESS_LIMIT = '100.000'
const UNLIMITED_ACCESS_LIMIT = '1.000.000'

const ACCESS_BY_COOKIE_PLAN = {
  free: `${FREE_ACCESS_LIMIT} acessos`,
  limited: `${LIMITED_ACCESS_LIMIT} acessos`,
  unlimited: `${UNLIMITED_ACCESS_LIMIT} de acessos`,
}

const UPGRADE_BENEFITS_LIST = [
  {
    name: 'Banner de cookies ilimitado',
    iconColor: theme.palette.primary.main,
  },
  {
    name: 'Treinamentos com certificado',
    iconColor: theme.palette.primary.secondary,
  },
  {
    name: 'Diagnóstico completo',
    iconColor: theme.palette.primary.main,
  },
  {
    name: 'Medidas de segurança',
    iconColor: theme.palette.primary.secondary,
  },
  {
    name: 'Tratamento de ameaças',
    iconColor: theme.palette.primary.main,
  },
  {
    name: 'Relatório de impacto',
    iconColor: theme.palette.primary.main,
  },
]

const COOKIE_PLANS_ADVANTAGES = {
  free: {
    requestsLimit: FREE_ACCESS_LIMIT,
    bannersLimit: 1,
    automaticScan: false,
  },
  limited: {
    requestsLimit: LIMITED_ACCESS_LIMIT,
    bannersLimit: 1,
    automaticScan: false,
  },
  unlimited: {
    requestsLimit: UNLIMITED_ACCESS_LIMIT,
    bannersLimit: 1,
    automaticScan: true,
  },
}

const BASE_DPOEASY_ADVANTAGES = [
  {
    name: 'Canal de Atendimento',
  },
  {
    name: 'Banner de Cookies',
  },
  {
    name: 'Políticas',
  },
  {
    name: 'Respostas Automáticas',
  },
]

const DPOEASY_ADVANTAGES = {
  free: [
    ...BASE_DPOEASY_ADVANTAGES,
    {
      name: 'Scanner de cookies',
    },
    {
      name: ACCESS_BY_COOKIE_PLAN['free'],
    },
    {
      name: '1 domínio',
    },
  ],
  limited: [
    ...BASE_DPOEASY_ADVANTAGES,
    {
      name: 'Scanner de cookies',
    },
    {
      name: ACCESS_BY_COOKIE_PLAN['limited'],
    },
    {
      name: '1 domínio',
    },
  ],
  unlimited: [
    ...BASE_DPOEASY_ADVANTAGES,
    {
      name: 'Scanner mensal de cookies',
    },
    {
      name: 'Atualização automática de políticas',
    },
    {
      name: ACCESS_BY_COOKIE_PLAN['unlimited'],
    },
    {
      name: '1 domínio',
    },
  ],
}

export default {
  BASE_DPOEASY_ADVANTAGES,
  UPGRADE_BENEFITS_LIST,
  DPOEASY_ADVANTAGES,
  COOKIE_PLANS_ADVANTAGES,
}
